var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditHist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 11.625H2.07113L9.7485 3.94762L8.80238 3.0015L1.125 10.6789V11.625ZM0 12.75V10.2116L9.89288 0.323062C10.0063 0.220062 10.1314 0.1405 10.2684 0.084375C10.4056 0.028125 10.5493 0 10.6997 0C10.8501 0 10.9957 0.0266879 11.1366 0.0800629C11.2776 0.133438 11.4024 0.218312 11.511 0.334687L12.4269 1.26206C12.5433 1.37069 12.6263 1.49569 12.6757 1.63706C12.7253 1.77844 12.75 1.91981 12.75 2.06119C12.75 2.21206 12.7243 2.356 12.6728 2.493C12.6213 2.63013 12.5393 2.75538 12.4269 2.86875L2.53838 12.75H0ZM9.26719 3.48281L8.80238 3.0015L9.7485 3.94762L9.26719 3.48281Z",
    fill: "#323848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditHist);
export default __webpack_public_path__ + "static/media/edit_hist.e946fa7b951b9b07a278e6f784601ada.svg";
export { ForwardRef as ReactComponent };